module.exports = __webpack_public_path__ + "img/sj.e9a20753.png";